if (!customElements.get('article-faq')) {
  class ArticleFaq extends HTMLElement {
    constructor() {
      super();
      this.items = [];
    }

    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.article-faq-item'));
      this.handleToggle = this.handleToggle.bind(this);
      this.items.forEach((item) => {
        item.addEventListener('toggle', this.handleToggle);
      });
    }

    disconnectedCallback() {
      this.items.forEach((item) => {
        item.removeEventListener('toggle', this.handleToggle);
      });
    }

    handleToggle(evt) {
      const item = evt.target;
      const summary = item.querySelector('summary');
      const question = summary ? summary.textContent.trim() : '';

      if (item.open) {
        document.dispatchEvent(new CustomEvent('on:faq:expand', {
          bubbles: true,
          detail: { question, element: item },
        }));
      } else {
        document.dispatchEvent(new CustomEvent('on:faq:collapse', {
          bubbles: true,
          detail: { question, element: item },
        }));
      }
    }
  }

  customElements.define('article-faq', ArticleFaq);
}
